import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomerData } from '../models/customer-data';
import { Orderpack } from '../models/orderpack';
import { Orderinfo } from '../models/orderinfo';

const BASE_API_URL = 'https://us-central1-ccentral-9b051.cloudfunctions.net/';

@Injectable({
  providedIn: 'root',
})
export class CloudFunctionsService {
  constructor(private http: HttpClient) {}

  getInitializationPack(
    appname: string,
    customerid: string = ''
  ): Promise<any> {
    return this.http
      .get(
        BASE_API_URL +
          'getInitializationPack_2?appname=' +
          appname +
          '&customerid=' +
          customerid +
          '&apptype=web',
        { responseType: 'json' }
      )
      .toPromise();
  }

  saveCustomerProfile(customerData: CustomerData): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        CustomerID: customerData.ID,
      }),
      responseType: 'text' as 'json',
    };

    let json = JSON.stringify({ CustomerData: customerData });

    return this.http
      .post(BASE_API_URL + 'saveCustomerData', json, httpOptions)
      .toPromise();
  }

  getCustomerOrderHistory(customerid: string = ''): Promise<any> {
    return this.http
      .get(
        BASE_API_URL + 'getCustomerOrderHistory_1?customerid=' + customerid,
        { responseType: 'json' }
      )
      .toPromise();
  }

  async callPlaceOrderPack(
    data: {
      clientID: string;
      unitID: string;
      customerID: string;
      hasPayCard: number;
      payCardNumber: number;
    },
    orderPack: Orderpack,
    orderInfo: Orderinfo
  ) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ClientID: data.clientID,
      UnitID: data.unitID,
      CustomerID: data.customerID,
    });

    if (data.hasPayCard === 1) {
      headers = headers.set('HasPayCard', 'true');
      headers = headers.set('PayCardNumber', String(data.payCardNumber));
    }

    const httpOptions = {
      headers: headers,
      responseType: 'text' as 'json',
    };

    const json = {
      OrderPack: JSON.stringify(orderPack),
      OrderInfo: JSON.stringify(orderInfo),
    };

    return this.http
      .post(BASE_API_URL + 'placeOrderPack_1', json, httpOptions)
      .toPromise();
  }
}
